export const failedToStartBpmnExecution = 'Failed to start execution';
export const failedToGetBpmnExecutionStatus = 'Failed to get execution status';
export const failedToLoadBpmnXml = 'Failed to load data';
export const failedToResumeBpmnExecution = 'Failed to resume execution';
export const failedToLoadGuideboxesMessage = 'Failed to load GuideBox data';
export const failedToFindElementMessage = 'Failed to find element';


